export type HeldReleaseTarget = {
  assignmentId: number;
  recommended?: boolean;
};

export type HeldReviewDetailLike = {
  mediaOperationId: string;
  bytesServerSafe: boolean;
  proposedAssignmentId: number | null;
  assignmentId: number | null;
  releaseTargets: HeldReleaseTarget[];
};

export const DEFAULT_HELD_RELEASE_REASON = 'Confirmed genuine — attach to store task';

export function createHeldReviewFormDefaults() {
  return {
    releaseReason: DEFAULT_HELD_RELEASE_REASON,
    abandonReason: '',
    abandonOpen: false,
    selectedAssignmentId: '',
  };
}

export function resolveDefaultHeldAssignmentId(detail: Pick<
  HeldReviewDetailLike,
  'proposedAssignmentId' | 'assignmentId' | 'releaseTargets'
>): string {
  const recommended = detail.releaseTargets.find(target => target.recommended);
  if (recommended) return String(recommended.assignmentId);
  if (detail.proposedAssignmentId) return String(detail.proposedAssignmentId);
  if (detail.assignmentId) return String(detail.assignmentId);
  if (detail.releaseTargets.length === 1) return String(detail.releaseTargets[0].assignmentId);
  return '';
}

export function isHeldReleaseTargetAllowed(
  releaseTargets: HeldReleaseTarget[],
  selectedAssignmentId: string,
): boolean {
  if (!selectedAssignmentId) return false;
  const assignmentId = Number(selectedAssignmentId);
  if (!Number.isInteger(assignmentId) || assignmentId <= 0) return false;
  return releaseTargets.some(target => target.assignmentId === assignmentId);
}

export function canSubmitHeldRelease(input: {
  detail: HeldReviewDetailLike | null | undefined;
  selectedAssignmentId: string;
  releaseReason: string;
}): boolean {
  if (!input.detail?.bytesServerSafe) return false;
  if (input.detail.releaseTargets.length === 0) return false;
  if (!input.releaseReason.trim()) return false;
  return isHeldReleaseTargetAllowed(input.detail.releaseTargets, input.selectedAssignmentId);
}
